import { createContext, useContext, useState } from "react";

const LangContext = createContext(null);
export const useLang = () => useContext(LangContext);

const dict = {
  brand: { en: "Mulankan", hi: "मूल्यांकन" },
  tagline: { en: "AI Voice Dictation", hi: "एआई वॉइस डिक्टेशन" },
  heroTitle: { en: "Your Destiny, Decoded by the Stars", hi: "आपका भाग्य, सितारों द्वारा उजागर" },
  heroSub: {
    en: "Guru Mulankan reads your future and solves your problems using your name, date of birth, birth place and time — powered by ancient Vedic wisdom and AI.",
    hi: "गुरु मूल्यांकन आपके नाम, जन्म तिथि, जन्म स्थान और समय से आपका भविष्य पढ़ते हैं और समस्याएँ सुलझाते हैं — प्राचीन वैदिक ज्ञान और एआई से संचालित।",
  },
  getPrediction: { en: "Get My Prediction", hi: "मेरी भविष्यवाणी पाएँ" },
  startChat: { en: "Start Live AstroChat @ ₹5/min", hi: "लाइव एस्ट्रोचैट शुरू करें @ ₹5/मिनट" },
  online: { en: "Guru Mulankan AI is Online", hi: "गुरु मूल्यांकन एआई ऑनलाइन है" },
  login: { en: "Login", hi: "लॉगिन" },
  register: { en: "Sign Up", hi: "साइन अप" },
  logout: { en: "Logout", hi: "लॉगआउट" },
  email: { en: "Email", hi: "ईमेल" },
  password: { en: "Password", hi: "पासवर्ड" },
  name: { en: "Full Name", hi: "पूरा नाम" },
  continueGoogle: { en: "Continue with Google", hi: "Google से जारी रखें" },
  dashboard: { en: "Dashboard", hi: "डैशबोर्ड" },
  wallet: { en: "Wallet", hi: "वॉलेट" },
  history: { en: "My Readings", hi: "मेरी भविष्यवाणियाँ" },
  addMoney: { en: "Add Money", hi: "पैसे जोड़ें" },
  birthTitle: { en: "Enter Your Birth Details", hi: "अपना जन्म विवरण दर्ज करें" },
  birthSub: { en: "The stars need these to reveal your path.", hi: "सितारों को आपका मार्ग बताने के लिए इनकी आवश्यकता है।" },
  dob: { en: "Date of Birth", hi: "जन्म तिथि" },
  tob: { en: "Time of Birth", hi: "जन्म समय" },
  pob: { en: "Place of Birth", hi: "जन्म स्थान" },
  save: { en: "Save & Continue", hi: "सहेजें और जारी रखें" },
  chooseReading: { en: "Choose a Reading", hi: "एक भविष्यवाणी चुनें" },
  generating: { en: "Consulting the stars...", hi: "सितारों से परामर्श किया जा रहा है..." },
  askQuestion: { en: "Ask a specific question (optional)", hi: "कोई विशेष प्रश्न पूछें (वैकल्पिक)" },
  getReading: { en: "Reveal Reading", hi: "भविष्यवाणी दिखाएँ" },
  send: { en: "Send", hi: "भेजें" },
  endChat: { en: "End Chat", hi: "चैट समाप्त करें" },
  balance: { en: "Balance", hi: "शेष राशि" },
  lowBalance: { en: "Low balance! Add money to continue.", hi: "कम शेष राशि! जारी रखने के लिए पैसे जोड़ें।" },
  typeMessage: { en: "Type your message to Guru...", hi: "गुरु को अपना संदेश लिखें..." },
  noReadings: { en: "No readings yet. Get your first prediction!", hi: "अभी तक कोई भविष्यवाणी नहीं। अपनी पहली भविष्यवाणी पाएँ!" },
  transactions: { en: "Transactions", hi: "लेन-देन" },
};

export function LangProvider({ children }) {
  const [lang, setLang] = useState(localStorage.getItem("samadhan_lang") || "en");
  const toggle = () => {
    const next = lang === "en" ? "hi" : "en";
    setLang(next);
    localStorage.setItem("samadhan_lang", next);
  };
  const t = (key) => (dict[key] ? dict[key][lang] : key);
  return <LangContext.Provider value={{ lang, setLang, toggle, t }}>{children}</LangContext.Provider>;
}
